/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setVendorDetails } from 'actions/vendorDetailsAction';
import FSBModal from 'components/common/FSBModal';
import VendorDetails from './components/VendorDetails';

const VendorDetailsDrawer = () => {
  const dispatch = useDispatch();
  const { status, selectedVendor } = useSelector(
    (state) => state.vendorDetailsReducer,
  );

  const drawerToggle = () => {
    dispatch(setVendorDetails({ status: false, selectedVendor: null }));
  };

  useEffect(() => {
    dispatch(setVendorDetails({ status: false, selectedVendor: null }));
  }, []);

  window.addEventListener('popstate', () => {
    drawerToggle();
  });

  return (
    <>
      {status && (
        <FSBModal
          // title={`${selectedVendor?.entityName} Details`}
          title={
            selectedVendor?.entityName
              ? `${selectedVendor?.entityName}`
              : 'Vendor Details'
          }
          open={status}
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          message=""
          modalClass="right-drawer right-drawer-details"
        >
          <VendorDetails
            drawerToggle={drawerToggle}
            vendorId={selectedVendor?.id}
          />
        </FSBModal>
      )}
    </>
  );
};

export default VendorDetailsDrawer;
